export default __webpack_public_path__ + "static/media/tik.d53d5e8e.svg";